import { render, staticRenderFns } from "./LoginSSO.vue?vue&type=template&id=b0ee400c&scoped=true"
import script from "./LoginSSO.vue?vue&type=script&lang=js"
export * from "./LoginSSO.vue?vue&type=script&lang=js"
import style0 from "./LoginSSO.vue?vue&type=style&index=0&id=b0ee400c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ee400c",
  null
  
)

export default component.exports